export class CostCenterPriceImportModel {
  counter: number = 0;
  branchCode: number = 0;
  costCenterCode: number = 0;
  conceptInvoicingCode: number = 0;
  articleCode: number = 0;
  quantityEspecialInvoicing: number = 0;
  swIsInvoiced: boolean = true;
  swInvoiceM2: boolean = false;
  unitValue: number = 0;

  constructor(counter: number,
    branchCode: number,
    costCenterCode: number,
    conceptInvoicingCode: number,
    articleCode: number,
    quantityEspecialInvoicing: number,
    swIsInvoiced: boolean,
    swInvoiceM2: boolean,
    unitValue: number
  ) {
    this.counter = counter;
    this.branchCode = branchCode;
    this.costCenterCode = costCenterCode;
    this.conceptInvoicingCode = conceptInvoicingCode;
    this.articleCode = articleCode;
    this.quantityEspecialInvoicing = quantityEspecialInvoicing;
    this.swIsInvoiced = swIsInvoiced;
    this.swInvoiceM2 = swInvoiceM2;
    this.unitValue = unitValue;
  }
}